import axios from "axios"
import { baseUrl } from "../utils/constants"

export const getNotificationsApi = async (userToken, page) => {
  return new Promise(async (resolve, reject) => {
    
    const url = `${baseUrl}/contractor/get-notifications?page=${page}`
    console.log(url);
    try {
      let response = await axios.get(url, {
        headers: {
          Authorization: userToken,
          "Content-Type": "application/x-www-form-urlencoded",
        },
      })
      resolve(response.data)
    } catch (error) {
      console.log("api error::", error.response?.data);
      reject(error.response?.data)
    }
  })
}